<template>
  <div v-if="Object.keys(topUser).length > 0" class="leaderList selectedList">
    <div class="titleText titleText_1">
      <span class="posText">{{ topUser.rank }}</span>
    </div>
    <div class="titleText titleText_2">
      <img src="../../src/assets/images/avtar.jpg" class="profileIcon" />
      <span class="userTitleText">{{ topUser.name }}</span>
    </div>
    <div class="titleText titleText_3">
      {{ ConvertSecondsTohours(topUser.total_duration) }}
    </div>
    <div class="titleText titleText_4">
      <img src="../../src/assets/images/rupees_icon.png" class="rupeesIcon" />
      {{ topUser.leader_board_score }}
    </div>
  </div>
</template>

<script>
import { constants } from 'crypto'
import { ConvertSecondsTohours } from '../utils/helper'
import InfiniteLoading from 'vue-infinite-loading'
import Vue from 'vue'
Vue.use(InfiniteLoading)

export default {
  name: 'LeaderBoardSelectedList',
  props: ['room_id', 'roomOwnerXAuthID', 'channel', 'topUser'],
  components: {
    InfiniteLoading
  },
  data() {
    return {
      LeaderBoardSelectedList: [
        'Position',
        'Name',
        'Duration Time',
        'Earn MPoint'
      ]
    }
  },
  methods: {
    ConvertSecondsTohours
  },
  mounted() {
    console.log('===this.topUser=', Object.keys(this.topUser).length)
  }
}
</script>
